import ContactUs from "./ContactUs";
import About  from "./About";
import Products from "./Products";
import { useTranslation } from "react-i18next";


function Home() {
  document.title = "Home";
  
  const { t } = useTranslation(["navbar"]);


  return (
    <>
    <Products trans={t}/>
    <About trans={t}/>
    <ContactUs trans={t}/>
    </>
  );
}

export default Home;
